// possible types for product
export const REGULAR_PRODUCT = 'regular_product';
export const FUNDRAISER_PRODUCT = 'fundraising_campaign';

// possible order status
export const FAILED = 'failed';
export const SUCCESS = 'succeeded';
export const REQUEST_AUTH = 'request_auth';
